import * as React from 'react'

function VmStetoskop({title, titleId, ...props}, svgRef) {
  return React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        fill: 'none',
        viewBox: '0 0 20 20',
        strokeWidth: 1.5,
        stroke: 'currentColor',
        'aria-hidden': 'true',
        ref: svgRef,
        'aria-labelledby': titleId,
      },
      props,
      {
        fill: props?.stroke || 'currentColor',
        stroke: 'none',
      }
    ),
    title
      ? React.createElement(
          'title',
          {
            id: titleId,
          },
          title
        )
      : null,
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      d: 'M7.33335 9.33331C6.4493 9.33331 5.60145 8.98212 4.97633 8.357C4.35121 7.73188 4.00002 6.88403 4.00002 5.99998V3.33331C4.00002 3.1565 4.07026 2.98693 4.19528 2.86191C4.32031 2.73688 4.48988 2.66665 4.66669 2.66665H5.33335C5.51016 2.66665 5.67973 2.59641 5.80476 2.47138C5.92978 2.34636 6.00002 2.17679 6.00002 1.99998C6.00002 1.82317 5.92978 1.6536 5.80476 1.52858C5.67973 1.40355 5.51016 1.33331 5.33335 1.33331H4.66669C4.13625 1.33331 3.62755 1.54403 3.25247 1.9191C2.8774 2.29417 2.66669 2.80288 2.66669 3.33331V5.99998C2.66754 6.75314 2.8512 7.49483 3.20189 8.16137C3.55257 8.8279 4.0598 9.39935 4.68002 9.82665C5.27591 10.352 5.75916 10.9926 6.10061 11.7099C6.44206 12.4272 6.63463 13.2062 6.66669 14C6.66669 15.2377 7.15835 16.4246 8.03352 17.2998C8.90869 18.175 10.0957 18.6666 11.3334 18.6666C12.571 18.6666 13.758 18.175 14.6332 17.2998C15.5084 16.4246 16 15.2377 16 14V13.24C16.6285 13.0777 17.1761 12.6918 17.5404 12.1546C17.9047 11.6175 18.0605 10.9659 17.9788 10.322C17.897 9.6781 17.5832 9.08616 17.0962 8.6571C16.6092 8.22804 15.9824 7.99132 15.3334 7.99132C14.6843 7.99132 14.0575 8.22804 13.5705 8.6571C13.0835 9.08616 12.7697 9.6781 12.6879 10.322C12.6062 10.9659 12.762 11.6175 13.1263 12.1546C13.4906 12.6918 14.0382 13.0777 14.6667 13.24V14C14.6667 14.884 14.3155 15.7319 13.6904 16.357C13.0653 16.9821 12.2174 17.3333 11.3334 17.3333C10.4493 17.3333 9.60145 16.9821 8.97633 16.357C8.35121 15.7319 8.00002 14.884 8.00002 14C8.03377 13.2052 8.22842 12.4256 8.57219 11.7083C8.91596 10.9909 9.4017 10.3508 10 9.82665C10.6178 9.39787 11.1224 8.82577 11.4707 8.15933C11.819 7.49288 12.0007 6.75196 12 5.99998V3.33331C12 2.80288 11.7893 2.29417 11.4142 1.9191C11.0392 1.54403 10.5305 1.33331 10 1.33331H9.33335C9.15654 1.33331 8.98697 1.40355 8.86195 1.52858C8.73693 1.6536 8.66669 1.82317 8.66669 1.99998C8.66669 2.17679 8.73693 2.34636 8.86195 2.47138C8.98697 2.59641 9.15654 2.66665 9.33335 2.66665H10C10.1768 2.66665 10.3464 2.73688 10.4714 2.86191C10.5964 2.98693 10.6667 3.1565 10.6667 3.33331V5.99998C10.6667 6.43772 10.5805 6.87117 10.413 7.27559C10.2454 7.68001 9.99991 8.04747 9.69038 8.357C9.38085 8.66653 9.01338 8.91206 8.60896 9.07958C8.20455 9.24709 7.77109 9.33331 7.33335 9.33331ZM15.3334 12C14.9797 12 14.6406 11.8595 14.3905 11.6095C14.1405 11.3594 14 11.0203 14 10.6666C14 10.313 14.1405 9.97389 14.3905 9.72384C14.6406 9.47379 14.9797 9.33331 15.3334 9.33331C15.687 9.33331 16.0261 9.47379 16.2762 9.72384C16.5262 9.97389 16.6667 10.313 16.6667 10.6666C16.6667 11.0203 16.5262 11.3594 16.2762 11.6095C16.0261 11.8595 15.687 12 15.3334 12Z',
    })
  )
}

const ForwardRef = React.forwardRef(VmStetoskop)
export default ForwardRef
